import type { DBTeam } from '@core/types/types.db';

export function isPro(team: DBTeam) {
  return (
    !!team.stripe_subscription_status &&
    team.stripe_subscription_status !== 'canceled'
  );
}
